import { Component, OnInit } from '@angular/core';
import { GridOptions } from "ag-grid/main";
import { Router } from "@angular/router";
import { Globals } from '../../globals';
import { TemplatesService } from 'app/services/template/TemplatesService';

@Component({
  selector: 'app-email-templates',
  templateUrl: './email-templates.component.html',
  styleUrls: ['./email-templates.component.scss']
})
export class EmailTemplatesComponent implements OnInit {

    loading: boolean = true;
    dataHeaders: any[];
    gridOptions: GridOptions;
    gridApi;
    gridColumnApi;
    overlayNoRowsTemplate;

    height: number;
    count: number;

    rowSelection: string;

    canEdit: boolean = false;
    canDelete: boolean = false;

    currentRowIndex: number;
    enableFilter: boolean = false;
    //filters: string[] = ['Name', 'Purpose', 'AssessmentType'];
    regularData: string[] = [];
    data360: string[] = [];


    constructor
    (
        private router: Router,
        private _Globals: Globals,
        private _TemplatesService: TemplatesService
    )
    {
        this.overlayNoRowsTemplate = "<span>No row to show</span>";
        this.rowSelection = "multiple";
    }

    ngOnInit() {
        this.gridOptions = <GridOptions>{};
        this.gridOptions.rowHeight = 45;
        this.gridOptions.headerHeight = 40;

        this.dataHeaders = this.createHeaders();

        //this.getGlobalEmailTemplates();
        this.getGlobalEmailTemplatesByType(1);
        this.getGlobalEmailTemplatesByType(2);
    }

    getGlobalEmailTemplatesByType(assessmentType: number) {
        this._TemplatesService.getGlobalEmailTemplatesByType(assessmentType).subscribe((data: any) => {
            console.log('response_getGlobalEmailTemplatesByType', data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);

                if (assessmentType === 1) {
                    this.regularData = _data;
                } else {
                    this.data360 = _data;
                }

                this.loading = false;
            } 

        });
    }

    //getEmailTemplates() {
    //    this.loading = true;
    //    this._GetEmailTemplates.getEmailTemplates().subscribe((data:any) => {
    //        console.log('response_GetEmailTemplates', data);
            
    //        if (this._Globals.validationToken(data.result.Result)) {
    //            this.data = JSON.parse(data.result.Data);
    //            console.log('this.data', this.data);
    //        }

    //        this.loading = false;

            
    //    });
    //}

    //getGlobalEmailTemplates() {
    //    this._GetGlobalEmailTemplates.getGlobalEmailTemplates().subscribe((data: any) => {
    //        console.log('response_GetGlobalEmailTemplates', data);

    //        if (this._Globals.validationToken(data.result.Result)) {
    //            this.data = JSON.parse(data.result.Data);
    //            console.log('this.standardData', this.data);

    //            //setTimeout(() => {
    //            //    $('#containerGrid .ag-body-viewport-wrapper').css({ "margin-top": "-32px", "position": "absolute", "width": "100%", "height": "111%" });
    //            //    if (this.data.length === 0) {
    //            //        $('#containerGrid .ag-body-viewport.ag-layout-normal').css('background', 'white');
    //            //    }
    //            //}, 10);
    //            this.loading = false;
    //        }
    //    });
    //}

  //removeTR(event) {
  //    console.log(event);
  //    event.target.parentNode.parentElement.remove();
  //  }

    gridSize(count: number) {
        this.count = count;
        console.log('count', this.count);
        this.height = (this.count + 1) * 43;
    }

    sizeToFit() {
        this.gridApi.sizeColumnsToFit();
        $('.ag-body-viewport').css('overflow', 'overlay');
    }

    onGridReady(params) {
        this.gridApi = params.api;
        this.sizeToFit();
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
    }

    createHeaders() {
        let columnDefs = new Array();
        
        //let actionsHeader = {
        //   headerName: 'Actions',
        //   field: '',
        //   minWidth: 85,
        //   width:85,
        //   suppressSizeToFit: true,
        //   suppressSorting: true,
        //   suppressMenu: true,
        //   cellRenderer: function (params) {
        //       let content = '';

        //       content += '<i id="editAction" class="material-icons">edit</i>';

        //       content += '<i id="deleteAction" class="material-icons custom-icons">delete</i>';

        //       return '<span style="margin-top: 4px !important;position: absolute;">' + content + '</span>';

        //   }
        //};
        //columnDefs.push(actionsHeader);        

        let nameHeader = {
            headerName: 'Name',
            field: 'Name',
            minWidth: 200,
            width: 200,
            // headerCheckboxSelection: true,
            // headerCheckboxSelectionFilteredOnly: true,
            // checkboxSelection: true,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
            }
        };
        columnDefs.push(nameHeader);

        let purposeHeader = {
            headerName: 'Purpose',
            field: 'Purpose',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(purposeHeader);

        let AssessmentTypeHeader = {
            headerName: 'Assessment Type',
            field: 'AssessmentType',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(AssessmentTypeHeader);

        //let nicheHeader = {
        //    headerName: 'Niche',
        //    field: 'Niche',
        //    minWidth: 120,
        //    width: 120,
        //    suppressSizeToFit: false,
        //    cellRenderer: function (params) {
        //        return params.value;
        //    }
        //};
        //columnDefs.push(nicheHeader);

        //let userTypeHeader = {
        //    headerName: 'User Type',
        //    field: 'UserType',
        //    minWidth: 120,
        //    width: 120,
        //    suppressSizeToFit: false,
        //    cellRenderer: function (params) {
        //        return params.value;
        //    }
        //};
        //columnDefs.push(userTypeHeader);

        return columnDefs; 
    }

    public onRowClicked(e) {
        console.log(e);
        if (e.event.target !== undefined) {
            let data = e.data;
            this.edit(data['Id']);
            //switch (e.event.target.id) {
            //   case "editAction":
            //       {
            //           //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
            //           //this.edit(data['Id'], data['Name'], data['Purpose'], data['AssessmentType'], data['Niche']);
            //           this.edit(data['Id']);
            //           break;
            //       }

            //   case "deleteAction":
            //       {
            //           //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
            //           this.delete(data['Id'],);
            //           break;
            //       }
            //}
        }
    }

    tabSelected(page) {
        console.log(page);
        this.sizeToFit();
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 500);
    }

    deselectAllCheckBox() {
        this.canEdit = false;
        this.canDelete = false;
        this.gridApi.forEachNode(function (node) {
            node.setSelected(false);
        });
    }

    onRowSelected(event) {
        console.log("onRowSelected", event);
        this.currentRowIndex = event.rowIndex;
        console.log('currentRowIndex', this.currentRowIndex);
    }

    onSelectionChanged(event) {
        console.log("onSelectionChanged ", event);
        var rowCount = event.api.getSelectedNodes().length;
        console.log("selection changed, ", rowCount + " rows selected");

        if (rowCount == 1) {
            this.canEdit = true;
        } else {
            this.canEdit = false;
        }

        if (rowCount == 1) {
            this.canDelete = true;
        } else {
            this.canDelete = false;
        }
    }

    editSelected() {
        if (this.canEdit) {
            let data = this.getSelectedRows();
            console.log("SELECTED ID", data);

            this.edit(data[0].Id);
        }
    }

    deleteSelected() {
        if (this.canDelete) {
            let data = this.getSelectedRows();
            console.log("SELECTED ID", data[0].Id);

            this.delete(data[0].Id);
        }
    }

    getSelectedRows(): any {
        console.log("SELECTED", this.gridApi.getSelectedRows());
        return this.gridApi.getSelectedRows();
    }

    edit(id: number) {
        console.log('edit');
        this.router.navigate(['/app/edit_emailtemplate', id]);
    }

    delete(id:number) {
        console.log('delete', id);
    }

    ////FILTER
    //toggleFilter() {
    //    if (this.enableFilter) {
    //        $('#containerGrid .ag-body-viewport-wrapper').css({ "margin-top": "-32px", "position": "absolute", "width": "100%", "height": "111%" });
    //        if (this.data.length === 0) {
    //            $('#containerGrid .ag-body-viewport.ag-layout-normal').css('background', 'white');
    //        }
    //        console.log('hide filter');
    //        this.filters.forEach((item) => {
    //            this.deselectFilter(item);
    //        });

    //    } else {
    //        $('#containerGrid .ag-body-viewport-wrapper').css({ "margin-top": "0", "position": "absolute", "width": "100%", "height": "100%" });
    //        if (this.data.length === 0) {
    //            $('#containerGrid .ag-body-viewport.ag-layout-normal').css('background', 'transparent');
    //        }
    //        console.log('show filter');
    //    }
    //    this.enableFilter = !this.enableFilter;
    //}

    //deselectFilter(filterName) {
    //    var filterComponent = this.gridApi.getFilterInstance(filterName);
    //    filterComponent.setModel(null);
    //    this.gridApi.onFilterChanged();
    //}

}
